import ProductCard from "@/components/global/ProductCard";
import MenuBanner from "./MenuBanner";
import { modifyMegaMenuTreeData } from "@/helpers/category";
import useFloatingMenu from "@/hooks/category/useFloatingMenu";
import { distributeElements } from "@/helpers/chunkArray";
import { useRouter } from "next/router";

const FloatMenu = ({
  children_data,
  parentUrl,
  sku_list,
  banners,
  isMenuOpen,
}) => {
  const { push } = useRouter();
  
  const { isShowBanners, isShowProducts, products } = useFloatingMenu({
    sku_list,
    banners,
  });

  const catChunks =
    isShowProducts || isShowBanners
      ? distributeElements(children_data || [], 2)
      : distributeElements(children_data || [], 4);

  return (
    <div
      className={`shadow-xl ${
        isMenuOpen ? "grid" : "hidden"
      } grid-cols-4 gap-3 z-mega-menu absolute top-[230px] left-1/2 -translate-x-1/2 w-[95%] p-3 bg-white rounded-xl border max-h-[65vh] overflow-y-auto`}
    >
      <div
        className={`flex self-start  ${
          isShowProducts || isShowBanners ? " col-span-2" : "col-span-4"
        }`}
      >
        {catChunks?.map((catChunk, idx) => {
          return (
            <div
              key={idx}
              className={`flex flex-col gap-2 mb-2 ${
                isShowProducts || isShowBanners ? "basis-1/2" : "basis-1/4"
              }`}
            >
              {catChunk?.map((cat) => {
                const childUrl = `${parentUrl}/${cat?.url_key}`;
                const modifiedData = modifyMegaMenuTreeData(cat?.children_data);

                return (
                  <div key={cat?.id}>
                    <span className="mb-3 font-bold cursor-pointer" onClick={() => push(childUrl)}>
                      {cat?.name}
                    </span>
                    <ul className="flex flex-col gap-2">
                      {modifiedData?.length > 0 &&
                        modifiedData.map((subCat) => {
                          const subChildUrl = `${childUrl}/${subCat?.url_key}`;

                          return (
                            <li
                              key={subCat?.id}
                              className="font-medium transition-all duration-500 cursor-pointer hover:text-primary-800"
                            >
                              <span onClick={() => push(subChildUrl)}>{subCat?.name}</span>
                            </li>
                          );
                        })}
                    </ul>
                  </div>
                );
              })}
            </div>
          );
        })}
      </div>

      {isShowProducts && (
        <div className="grid grid-cols-2 col-span-2 gap-3">
          {products?.slice(0, 2)?.map((product, i) => (
            <ProductCard product={product} key={i} />
          ))}
        </div>
      )}

      {isShowBanners && (
        <div className="flex gap-3 col-span-2">
          <div className="flex flex-col gap-3 basis-1/2">
            <MenuBanner {...banners[0]} />
            <MenuBanner {...banners[1]} />
          </div>
          <div className="basis-1/2">
            <MenuBanner {...banners[2]} />
          </div>
        </div>
      )}
    </div>
  );
};

export default FloatMenu;
